import { defineRecipe } from "@chakra-ui/react"

export const codeRecipe = defineRecipe({
  base: {
    alignItems: "center",
    borderRadius: "l2",
    display: "inline-flex",
    fontFamily: "mono",
  },
  className: "chakra-code",
  defaultVariants: {
    size: "sm",
    variant: "subtle",
  },
  variants: {
    size: {
      sm: {
        minH: "5",
        px: "1.5",
        textStyle: "xs",
      },
      md: {
        minH: "6",
        px: "2",
        textStyle: "sm",
      },
      lg: {
        minH: "7",
        px: "2.5",
        textStyle: "sm",
      },
      xs: {
        minH: "4",
        px: "1",
        textStyle: "2xs",
      },
    },
    variant: {
      outline: {
        color: "colorPalette.fg",
        shadow: "inset 0 0 0px 1px var(--shadow-color)",
        shadowColor: "colorPalette.muted",
      },
      plain: {
        color: "colorPalette.fg",
      },
      solid: {
        bg: "colorPalette.solid",
        color: "colorPalette.contrast",
      },
      subtle: {
        bg: "colorPalette.subtle",
        color: "colorPalette.fg",
      },
      surface: {
        bg: "colorPalette.subtle",
        color: "colorPalette.fg",
        shadow: "inset 0 0 0px 1px var(--shadow-color)",
        shadowColor: "colorPalette.muted",
      },
    },
  },
})
